<template>
  <div style="height: 100%">
    <div id="carLeft">
      <group-tree isMore @groups="reGroups" @group="reGroup" :filterGroup='filterGroup'></group-tree>
    </div>
    <div id="carRight">
      <ly-search
        v-model="keyword"
        placeholder="搜索车辆"
        @search="getCarList([])"
        style="margin-bottom: 10px"
      />
      <div
        v-if="isMore"
        v-show="carList.length > 0"
        style="margin-top: 4px; margin-bottom: 10px"
      >
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
          >全选</Checkbox
        >
      </div>
      <div id="carList" class="gundongtiao">
        <ul v-if="isMore">
          <li v-for="(item, index) in carList" :key="index">
            <Checkbox
              @on-change="checkAllGroupChange(item)"
              style="width: 100%; text-overflow: ellipsis; white-space: nowrap"
              v-model="item.check"
              ><img
                class="dasimg"
                :src="axios.platConfig.fileUri + 'mapicon/'  + item.carTypeIcon + '/big.png'"
              />{{ item.carNo }}</Checkbox
            >
          </li>
        </ul>
        <ul v-else>
          <li
            v-for="(item, index) in carList"
            :key="index"
            @click="clickLi(item)"
          >
            <img
              class="dasimg"
              :src="axios.platConfig.fileUri + 'mapicon/'  + item.carTypeIcon + '/big.png'"
            />
            {{ item.carNo }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["isMore", "filter","filterGroup"],
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      carList: [],
      groupIdList: [],
      groupId: [],
      keyword: "",
      checkCars: [],
    };
  },
  methods: {
    reGroup(y, v) {
      this.reGroups(v);
    },
    reGroups(v) {
      this.groupIdList = [];
      for (const i in v) {
        this.groupIdList.push(v[i].id);
      }
      if (this.groupIdList.length == 0 && this.groupId.length > 0) {
        this.getCarList(this.groupId);
      } else {
        this.getCarList(this.groupIdList);
      }
    },
    getCarList(list) {
      /* if (list.length == 0 && this.keyword.length == 0) {
        this.carList = [];
        return;
      } */
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/car/list",
        
        data: {
          groupIdList: list,
          keyword: this.keyword,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        var filter = this.filter;
        data = data.filter(function (item) {
          return filter ? item.labelList.includes(filter) : item;
        });
        for (let i = 0; i < data.length; i++) {
          data[i].check = false;
        }
        this.carList = data;
      });
    },
    checkAllGroupChange(data) {
      var a = this.carList;
      var b = this.checkCars;
      b = [];
      for (const i in a) {
        if (a[i].check) {
          b.push(a[i]);
        }
      }
      this.$emit("cars", b);
      if (b.length == a.length) {
        this.checkAll = true;
        this.indeterminate = false;
      } else if (b.length < a.length && b.length != 0) {
        this.indeterminate = true;
      } else if (b.length == 0) {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    handleCheckAll() {
      this.checkAll = !this.checkAll;
      var b = this.checkAll ? this.carList : [];
      this.$emit("cars", b);
      for (const i in this.carList) {
        this.carList[i].check = this.checkAll;
      }

      this.indeterminate = false;
    },

    clickLi(row) {
      this.$emit("car", row);
    },
  },
  mounted() {},
  watch: {
    keyword(v) {
      if (v.length == 0) {
        this.getCarList([]);
      }
    },
  },
};
</script>
<style lang="">
#carLeft,
#carRight {
  width: 50%;
  height: 100%;
  float: left;
}
#carRight {
  padding-left: 10px;
  border-left: solid 1px #ccc;
}
#carRight li:hover {
  background: #ebf8fc;
  cursor: pointer;
}
#carRight li .dasimg {
  vertical-align: middle;
  height: 18px;
  margin-right: 4px;
}
#carList li {
  padding: 2px 4px;
}
#carList {
  height: calc(100% - 80px);
}
</style>


// WEBPACK FOOTER //
// src/components/common/carTool.vue